/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AcceptContractTermsRequest } from './';
import {
    AcceptContractTermsRequestFromJSON,
    AcceptContractTermsRequestFromJSONTyped,
    AcceptContractTermsRequestToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcceptSubcontractingContractTermsRequest
 */
export interface AcceptSubcontractingContractTermsRequest extends AcceptContractTermsRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptSubcontractingContractTermsRequest
     */
    clientTermsId: string;
}

/**
 * Check if a given object implements the AcceptSubcontractingContractTermsRequest interface.
 */
export function instanceOfAcceptSubcontractingContractTermsRequest(value: object): value is AcceptSubcontractingContractTermsRequest {
    if (!('clientTermsId' in value) || value['clientTermsId'] === undefined) return false;
    return true;
}

export function AcceptSubcontractingContractTermsRequestFromJSON(json: any): AcceptSubcontractingContractTermsRequest {
    return AcceptSubcontractingContractTermsRequestFromJSONTyped(json, false);
}

export function AcceptSubcontractingContractTermsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptSubcontractingContractTermsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...AcceptContractTermsRequestFromJSONTyped(json, ignoreDiscriminator),
        'clientTermsId': json['clientTermsId'],
    };
}

export function AcceptSubcontractingContractTermsRequestToJSON(value?: AcceptSubcontractingContractTermsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...AcceptContractTermsRequestToJSON(value, true),
        'clientTermsId': value['clientTermsId'],
    };
}

